module.exports = __webpack_public_path__ + "img/arrow-right-red.b49d24d2.svg";